// List of Indian states and union territories
export const states = [
  "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh",
  "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand", "Karnataka",
  "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur", "Meghalaya", "Mizoram",
  "Nagaland", "Odisha", "Punjab", "Rajasthan", "Sikkim", "Tamil Nadu",
  "Telangana", "Tripura", "Uttar Pradesh", "Uttarakhand", "West Bengal",
  "Andaman and Nicobar Islands", "Chandigarh",
  "Dadra and Nagar Haveli and Daman and Diu", "Lakshadweep", "Delhi", "Puducherry",
];

// Contact Info
export const phoneNumbers = ["7520022055", "7520022014"];
export const emailAddress = "info@sonamagrotech.com";
export const mailtoLink = `mailto:${emailAddress}`;

// Function to call the first phone number
export const handlePhoneClick = () => {
  window.location.href = `tel:${phoneNumbers[0]}`;
};

// If you want to generate multiple tel links (for UI)
export const telLinks = phoneNumbers.map((num) => ({
  number: num,
  href: `tel:${num}`,
}));
